import React from "react";
import { useModal } from "../../hooks/useModal";
import Modal from "./Modal";

const ModalContainer: React.FC = () => {
	const { showCancelModal, showConfirmModal, showErrorModal, modalType } =
		useModal();

	return (
		<>
			{showCancelModal && <Modal type="cancel" />}
			{showConfirmModal && <Modal type="confirm" />}
			{showErrorModal && <Modal type="error" />}
		</>
	);
};

export default ModalContainer;
